import {ApplicationRef, ComponentFactoryResolver, Injectable, Injector} from '@angular/core';
import {MmBimService} from '../../mm-bim.service';
import {PromptDialogService} from '@mydocma/component-library/src/lib/prompt-dialog';
import {TranslateService} from '@ngx-translate/core';
import {MmBimDialogComponent} from './bim-dialog.component';
import {BimModelAvailabilityService} from "../../bim-model-availability.service";
import {BimModelSelectionService} from "@mydocma/co/src/lib/common";

@Injectable()
export class MmBimDialogService {

  private bimViewComponentRef: any;


  constructor(private mmBimService: MmBimService,
              private readonly dialogService: PromptDialogService,
              private translateService: TranslateService,
              private bimModelAvailabilityService: BimModelAvailabilityService,
              private componentFactoryResolver: ComponentFactoryResolver,
              private injector: Injector,
              private bimModelSelectionService: BimModelSelectionService,
              private appRef: ApplicationRef) {

  }

  public IsOpen(): boolean {
    return !!this.bimViewComponentRef;
  }


  public async openBimDialog(startInCreationMode = false) {
    const bimModels = this.bimModelAvailabilityService.structureBimModels;
    if (!bimModels?.length) {
      await this.dialogService.showNotificationDialog({
        title: this.translateService.instant('MM.bimViewer.noBimModelAvailableDialog.title'),
        subTitle: this.translateService.instant('MM.bimViewer.noBimModelAvailableDialog.subTitle'),
      });
      return;
    }

    let selectedModel;

    if (bimModels.length === 1) {
      selectedModel = bimModels[0];
    } else {
      selectedModel = await this.bimModelSelectionService.startBimModelSelectionDialog(bimModels);
      if (!selectedModel) {
        return;
      }
    }

    await this.mmBimService.setSelectedBimModel(selectedModel);

    if (!this.mmBimService?.bimPlans?.length) {
      await this.dialogService.showNotificationDialog({
        title: this.translateService.instant('MM.bimViewer.noBimPlansAvailableDialog.title'),
        subTitle: this.translateService.instant('MM.bimViewer.noBimPlansAvailableDialog.subTitle'),
        content: this.translateService.instant('MM.bimViewer.noBimPlansAvailableDialog.content'),
      });
      return;
    }

    if (this.bimViewComponentRef) {
      return;
    }

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(MmBimDialogComponent);
    const componentRef = componentFactory.create(this.injector);
    this.bimViewComponentRef = componentRef;

    componentRef.instance.startInCreationMode = startInCreationMode;
    this.appRef.attachView(componentRef.hostView);

    const componentNativeElement = componentRef.location.nativeElement;
    const appFrameElement = document.querySelector('.app-frame');
    appFrameElement.parentNode.append(componentNativeElement, appFrameElement.nextSibling);

    this.mmBimService.IsBimViewOpen = this.IsOpen();
  }



  public async closeBimDialog() {
    if (this.bimViewComponentRef) {
      const componentNativeElement = this.bimViewComponentRef.location.nativeElement;
      componentNativeElement.parentNode.removeChild(componentNativeElement);
      this.bimViewComponentRef.destroy();
      this.bimViewComponentRef = null;
      this.mmBimService.IsBimViewOpen = this.IsOpen();
    }
  }
}
